import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

type Lang = 'ir' | 'en';

export const useLocalePath = () => {
  const { lang } = useParams<{ lang: string }>();
  const location = useLocation();
  // Fallback: try to detect from current URL path
  const pathLang = location.pathname.split('/')[1];
  const currentLang: Lang = (lang === 'en' || pathLang === 'en') ? 'en' : 'ir';

  const lp = useCallback((path: string) => {
    // If path already starts with /ir or /en, return as is
    if (path.startsWith('/ir/') || path.startsWith('/en/') || path === '/ir' || path === '/en') {
      return path;
    }
    // If path starts with /, prefix with lang
    if (path.startsWith('/')) {
      return `/${currentLang}${path}`;
    }
    return `/${currentLang}/${path}`;
  }, [currentLang]);

  return { lang: currentLang, lp };
};

export const useLocalizedNavigate = () => {
  const navigate = useNavigate();
  const { lp } = useLocalePath();

  return useCallback((path: string) => {
    navigate(lp(path));
  }, [navigate, lp]);
};
